import React  from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { ReactComponent as SearchIcon } from '../../../images/search.svg';

const { Search } = Input;

const SearchAddress = styled(Search)`
  &&& {
    border-radius: 12px;
    padding: 0 45px;
    height: 44px;
    background: white;
    .ant-input-suffix {
      display: none;
    }
    .ant-input {
      background: white;
    }
  }
`;
const Wrapper = styled.div`
  &&& {
    position: relative;
    .icon-search {
      position: absolute;
      z-index: 1;
      font-size: 18px;
      top: 14px;
      left: 16px;
    }
  }
`;

function Seacrh({ search }) {
  const {t} = useTranslation();
  const handleSearch = (value) => {
    search({
      search: value,
    });
  };
  return (
    <>
      <Wrapper>
        <SearchIcon className="icon-search" />
        <SearchAddress
          onSearch={handleSearch}
          className="rounded-md"
          placeholder={t('searchInTheEventFeed')}
        />
      </Wrapper>
    </>
  );
}

Seacrh.propTypes = {};

export default Seacrh;
